export default __webpack_public_path__ + "static/media/Book News Paper Cuttings.f7b283cb.pdf";